import { post,get,postJson,postLogin} from './axios'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/login'
const RESOURCE_BASE_PATH = '/login'


export const login = p => postLogin(`${RESOURCE_BASE_PATH}/testLogin`, p);


export const logout = p => post(`${RESOURCE_BASE_PATH}/logout`, p);



// ----------7.1新加新登录页接口

export const login1 = p => post(`/login/platform`, p);




// export const cutHostToSonShop = p => post(`${RESOURCE_BASE_PATH}/cutHostToSonShop`, p);

// export const loginTimeout = p => get(`${RESOURCE_BASE_PATH}/loginTimeout`, p);

// // 全渠道登楼接口
// export const allChannelLogin = p => get(`${RESOURCE_BASE_PATH}/allChannelLogin`, p);